import { SET_APHORISMS, CREATE_APHORISM, DELETE_APHORISM } from '../constants/aphorisms';
import aphorismsAPI from '../../_api/aphorisms';
import { reset, stopSubmit } from 'redux-form';
import { incrementAphorismsCount, decrementAphorismsCount } from './auth';


const setAphorisms = (count, list) => ({ type: SET_APHORISMS, count, list });
const pushAphorism = (item) => ({ type: CREATE_APHORISM, item });
const removeAphorism = (id) => ({ type: DELETE_APHORISM, id });

export const getAphorisms = (page) => async (dispatch) => {
  const response = await aphorismsAPI.getList(page);
  if (response) dispatch(setAphorisms(response.count, response.results));
};

export const createAphorism = (payload) => async (dispatch) => {
  const response = await aphorismsAPI.create(payload);
  if (response) {
    dispatch(pushAphorism(response));
    dispatch(reset('aphorismForm'));
    dispatch(incrementAphorismsCount());
  } else {
    dispatch(stopSubmit('aphorismForm', { 'account': gettext(response.data['non_field_errors'][0]) }));
  }
};

export const deleteAphorism = (id, checked) => async (dispatch) => {
  const response = await aphorismsAPI.delete(id);
  if (response){
    dispatch(removeAphorism(id));
    if (!checked) dispatch(decrementAphorismsCount());
  }
};